export const getPagination = (current: number, total: number, delta = 2): (number | string)[] => {
    // Always include the first and last pages.
    const pages: Set<number> = new Set([1, total]);

    // Include pages in the "window" around the current page.
    for (let i = current - delta; i <= current + delta; i++) {
        if (i >= 1 && i <= total) {
            pages.add(i);
        }
    }

    // Sort the selected pages.
    const sortedPages: number[] = Array.from(pages).sort((a, b) => a - b);

    // Build the final result, inserting ellipses when needed.
    const result: (number | string)[] = [];
    let lastPage: number | null = null;

    for (const page of sortedPages) {
        if (lastPage !== null) {
            if (page - lastPage === 2) {
                // There is exactly one missing page, so insert it directly.
                result.push(lastPage + 1);
            } else if (page - lastPage > 2) {
                // More than one missing page, so insert an ellipsis.
                result.push('...');
            }
        }
        result.push(page);
        lastPage = page;
    }

    return result;
};
